import { useEffect, useState } from "react";

import { Button, Modal, Text } from "@pentabd/ui";
import { ProfileInfoCard } from "@components";
import AssignModalTable from "./AssignModalTable";

import { getProducts } from "@api/inventory/unAssignedProductListData";

import { EmployeeCommonInfoType } from "@type/HRM/employee-common-info";
import { RequisitionProductDataType } from "@type/inventory/requisition-details";
import { useTranslation } from "react-i18next";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  rowData: RequisitionProductDataType;
  handleProductSelection: any;
  selectedProducts: any;
  clearSelection: any;
  handleAssignAmount: any;
};

const AssignModal = ({
  isOpen,
  onClose,
  rowData,
  handleProductSelection,
  selectedProducts,
  clearSelection,
  handleAssignAmount,
}: Props) => {
  const { t } = useTranslation();
  const [productsList, setProductsList] = useState([]);
  const [approvedAmount, setApprovedAmount] = useState<number>(
    rowData.data.approvedAmount,
  );
  const [notAssignedAmount, setNotAssignedAmount] = useState<number>(
    rowData.data.approvedAmount - rowData.data.approvedTotalAmount,
  );
  const [employee, setEmployee] = useState<EmployeeCommonInfoType>(
    rowData.employee,
  );
  const [productType, setProductType] = useState<string>("");
  // const [products, setProducts] = useState<any>([]);

  useEffect(() => {
    const getData = async () => {
      const { data, employee } = rowData;

      const res = await getProducts(data?.nameId, data?.type);
      setProductType(data?.type);
      setProductsList(res.data);
      setEmployee(employee);
      setApprovedAmount(data.approvedAmount);
      setNotAssignedAmount(data.approvedAmount - data.approvedTotalAmount);
    };
    getData();
  }, [rowData]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} overlay>
      <div className="p-5 modal_width">
        <div className="border-bottom p-6">
          <ProfileInfoCard employee={employee} />
        </div>

        <div className="p-0 m-0 py-6">
          <div className="mt-5">
            <Text component="p" weight="bold" size="md" className="mb-5">
              {t("INVENTORY_REQUISITION.REQUISITION_DETAILS.ASSIGN_HEADER")}
            </Text>
            <Text component="p" weight="light" size="sm" className="mb-5">
              {t(
                "INVENTORY_REQUISITION.REQUISITION_DETAILS.ASSIGN_APPROVE_AMOUNT",
              )}{" "}
              <span className="fw-bold">{approvedAmount}</span>,
              {notAssignedAmount ? (
                <>
                  {" "}
                  {t(
                    "INVENTORY_REQUISITION.REQUISITION_DETAILS.NOT_ASSIGN_AMOUNT",
                  )}{" "}
                  <span className="fw-bold">{notAssignedAmount}</span>
                </>
              ) : (
                ""
              )}
            </Text>
          </div>

          <div className="mt-10">
            <AssignModalTable
              productsList={productsList}
              handleProductSelection={handleProductSelection}
              notAssignedAmount={notAssignedAmount}
              selectedProducts={selectedProducts}
              productType={productType}
              handleAssignAmount={handleAssignAmount}
              rowData={rowData}
            />
          </div>

          <div className="mt-5 text-end">
            <Button
              fill="outline"
              type="primary"
              size="xs"
              className="me-5"
              onClick={(e) => {
                clearSelection();
              }}
            >
              {t(
                "INVENTORY_REQUISITION.REQUISITION_DETAILS.ASSIGN_MODAL_CLEAR",
              )}
            </Button>
            <Button
              fill="fill"
              type="primary"
              size="xs"
              onClick={(e) => {
                onClose();
              }}
            >
              {t("INVENTORY_REQUISITION.REQUISITION_DETAILS.ASSIGN_MODAL_SAVE")}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AssignModal;
